import { render } from "./AutomationArchive.vue?vue&type=template&id=70692d06&scoped=true"
import script from "./AutomationArchive.vue?vue&type=script&lang=js"
export * from "./AutomationArchive.vue?vue&type=script&lang=js"

import "./AutomationArchive.vue?vue&type=style&index=0&id=70692d06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70692d06"]])

export default __exports__